import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "fr";
    return localStorage.getItem("flow_lang") || "fr";
  });

  useEffect(() => {
    localStorage.setItem("flow_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (key) => {
    const parts = key.split(".");
    let v = translations[lang];
    for (const p of parts) {
      if (v && typeof v === "object" && p in v) v = v[p];
      else return key;
    }
    return v;
  };

  const toggle = () => setLang((l) => (l === "fr" ? "en" : "fr"));

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
};
